import styled, { css } from 'vue3-styled-components';

export const ManagePageContainer = styled.div`
    padding: 0 24px;
    margin-left: 260px;
    min-height: 100vh;
    background: #f8fafc;
    border-radius: 10px;
`;

export const MainContentWrapper = styled.div`
    max-width: 1400px;
    margin: 0 auto;
    padding: 24px 0;
`;

// 헤더 섹션
export const HeaderSection = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 32px;
    background: white;
    padding: 24px 32px;
    border-radius: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const HeaderTitle = styled.div`
    h1 {
        font-size: 28px;
        font-weight: 700;
        color: #1e293b;
        margin: 0 0 8px 0;
    }
    
    span {
        color: #64748b;
        font-size: 16px;
        font-weight: 400;
    }
`;

export const ButtonGroup = styled.div`
    display: flex;
    gap: 10px;
    margin-left: auto;
`;

export const AddButton = styled.button`
    display: flex;
    align-items: center;
    gap: 3px;
    background: #0f4c5c;
    color: white;
    border: none;
    padding: 3px 10px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
    /* margin-left: auto; 제거 */
    
    &:hover {
        transform: translateY(-2px);
        background: #0f5c6c;
    }
`;

// 검색 섹션
export const SearchSection = styled.div`
    margin-bottom: 32px;
`;

export const SearchCard = styled.div`
    background: white;
    padding: 24px 32px;
    border-radius: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

export const SearchRow = styled.div`
    display: flex;
    align-items: center;
    gap: 24px;
    margin-bottom: 16px;
    
    &:last-child {
        margin-bottom: 0;
    }
`;

export const SearchGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    
    label {
        font-weight: 600;
        color: #374151;
        min-width: 80px;
    }
`;

export const SearchField = styled.div`
    select {
        padding: 10px 16px;
        border: 2px solid #e5e7eb;
        border-radius: 10px;
        background: white;
        color: #374151;
        font-weight: 500;
        transition: all 0.2s ease;
        
        &:focus {
            outline: none;
            border-color: #0f4c5c;
        }
    }
`;

export const SearchInput = styled.input`
    padding: 10px 16px;
    border: 2px solid #e5e7eb;
    border-radius: 5px;
    font-size: 14px;
    
    &:focus {
        outline: none;
        border-color: #0f4c5c;
    }
    
    &::placeholder {
        color: #9ca3af;
    }
`;

export const SearchInput2 = styled.input`
    padding: 7px 14px;
    border: 2px solid #e5e7eb;
    border-radius: 5px;
    font-size: 14px;
    max-width: 100px;
    
    &:focus {
        outline: none;
        border-color: #0f4c5c;
    }
    
    &::placeholder {
        color: #9ca3af;
    }
`;

export const SelectionInfo = styled.div`
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #0f4c5c;
    font-weight: 500;
    margin-left: 15px;
`;

// 체크박스 선택된 행 스타일
export const CheckboxSelectedRow = styled.tr`
    background-color: #e8f4f8;
    
    &:hover {
        background-color: #d1e7dd;
    }
`;

export const SearchButton = styled.button`
    padding: 8px 10px;
    background: #0f4c5c;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    
    &:hover {
        transform: translateY(-1px);
        background: #0f5c6c;
    }
`;

// 필터 관련
export const FilterGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    
    label {
        font-weight: 600;
        color: #374151;
        min-width: 80px;
    }
`;

export const FilterChips = styled.div`
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
`;

const chipProps = css`
    ${props => props.active && css`
        background: #0f4c5c;
        color: white;
        border-color: #0f4c5c;
    `}
`;

export const FilterChip = styled.div`
    padding: 8px 16px;
    border: 2px solid #e5e7eb;
    border-radius: 20px;
    background: white;
    color: #374151;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s ease;
    ${chipProps}
    
    &:hover {
        border-color: #0f4c5c;
    }
`;

// 통계 섹션
export const StatsSection = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 20px;
    margin-bottom: 32px;
`;

export const StatsCard = styled.div`
    background: white;
    padding: 24px;
    border-radius: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    text-align: center;
    transition: all 0.2s ease;
    
    &:hover {
        transform: translateY(-4px);
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
    }
`;

export const StatsNumber = styled.div`
    font-size: 32px;
    font-weight: 700;
    color: #cc5803;
    margin-bottom: 8px;
`;

export const StatsLabel = styled.div`
    font-size: 14px;
    color: #64748b;
    font-weight: 500;
`;

// * 테이블 섹션
export const TablesContainer = styled.div`
    display: flex;
    gap: 24px;
    margin-bottom: 32px;

    @media (max-width: 1400px) {
        flex-direction: column;
        gap: 32px;
    }
`;

export const TableSection = styled.div`
    background: white;
    border-radius: 16px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    flex: 1;
    min-width: 0;
`;

export const TableHeader = styled.div`
    display: flex;
    align-items: center;
    padding: 20px 32px;
    border-bottom: 1px solid #e5e7eb;
    flex-wrap: wrap;
    gap: 16px;
`;

export const SubTitle = styled.h2`
    font-size: 20px;
    font-weight: 700;
    color: #1e293b;
    margin: 0;
    margin-right: 15px;
`;

export const TableContainer = styled.div`
    overflow-x: auto;
`;

export const ModernTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    
    th, td {
        padding: 10px;
        text-align: center;
        border-bottom: 1px solid #f1f5f9;
    }
    
    th {
        background: #f8fafc;
        font-weight: 600;
        color: #374151;
        font-size: 14px;
        white-space: nowrap;
    }
    
    td {
        color: #1e293b;
        font-size: 14px;
    }
    
    tbody tr {
        cursor: pointer;
        transition: all 0.2s ease;
        
        &:hover {
            background: #f8fafc;
        }
        
        &.selected {
            background: #ffeccc;
            border-left: 4px solid #fb8b24;
        }
    }
`;

// 수급자 관련 스타일
export const BeneficiaryName = styled.div`
    font-weight: 600;
    color: #1e293b;
    font-size: 15px;
`;

export const DocumentCountBadge = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 24px;
    height: 24px;
    padding: 0 8px;
    background: #0f4c5c;
    color: white;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 600;
`;

// 서류 정보
export const DocumentInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const FileIcon = styled.div`
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f0fdf4;
    border-radius: 8px;
    font-size: 20px;
`;

export const InfoText = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

export const FileName = styled.div`
    font-weight: 600;
    color: #1e293b;
    font-size: 14px;
`;

export const ClientName = styled.div`
    font-weight: 500;
    color: #374151;
`;

export const FileSize = styled.div`
    color: #6b7280;
    font-size: 13px;
`;

export const ApproverInfo = styled.div`
    color: #374151;
    font-size: 13px;
`;

// 서류 유형 칩
const documentTypeProps = css`
    ${props => {
        switch (props.type) {
            case 'contract':
                return css`
                    background: #dbeafe;
                    color: #1e40af;
                `;
            case 'id':
                return css`
                    background: #dcfce7;
                    color: #166534;
                `;
            case 'medical':
                return css`
                    background: #fef3c7;
                    color: #92400e;
                `;
            case 'certificate':
                return css`
                    background: #e0f2fe;
                    color: #0369a1;
                `;
            case 'application':
                return css`
                    background: #fce7f3;
                    color: #be185d;
                `;
            default:
                return css`
                    background: #f1f5f9;
                    color: #475569;
                `;
        }
    }}
`;

export const DocumentTypeChip = styled.span`
    padding: 6px 12px;
    border-radius: 12px;
    font-size: 13px;
    font-weight: 600;
    ${documentTypeProps}
`;

// 페이지네이션
export const PaginationContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 32px;
    border-top: 1px solid #e5e7eb;
`;

export const Pagination = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const PaginationButton = styled.button`
    padding: 4px 6px;
    border: 2px solid #e5e7eb;
    background: white;
    color: #374151;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 500;
    transition: all 0.2s ease;
    
    &:hover:not(:disabled) {
        border-color: #fb8b24;
        color: #fb8b24;
    }
    
    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

const paginationNumberProps = css`
    ${props => props.active && css`
        background: #fb8b24;
        color: white;
        border-color: #fb8b24;
    `}
`;

export const PaginationNumber = styled.button`
    min-width: 36px;
    height: 36px;
    padding: 0 8px;
    border: 2px solid #e5e7eb;
    background: white;
    color: #374151;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 500;
    transition: all 0.2s ease;
    white-space: nowrap;
    ${paginationNumberProps}
    
    &:hover:not(:disabled) {
        border-color: #fb8b24;
        color: #fb8b24;
    }
`;

export const LoadingContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 60px 20px;
`;

export const LoadingSpinner = styled.div`
    font-size: 16px;
    color: #666;
`;

export const EmptyState = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 110px 20px;
    text-align: center;
`;

export const EmptyIcon = styled.div`
    font-size: 48px;
    margin-bottom: 16px;
    opacity: 0.5;
`;

export const EmptyMessage = styled.h3`
    font-size: 18px;
    color: #333;
    margin-bottom: 8px;
`;

export const EmptySubMessage = styled.p`
    font-size: 14px;
    color: #666;
    margin: 0;
`;

export const FileTypeChip = styled.span`
    display: inline-block;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    background-color: #f0f0f0;
    color: #333;
`;

export const ActionButtons = styled.div`
    display: flex;
    justify-content: center;
    gap: 8px;
`;

export const ActionButton = styled.button`
    padding: 8px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
    transition: background-color 0.2s;

    &.download {
        background-color: #e3f2fd;
        &:hover {
            background-color: #bbdefb;
        }
    }

    &.delete {
        background-color: #ffebee;
        &:hover {
            background-color: #ffcdd2;
        }
    }
`;